import { render } from "./releaseMemory.vue?vue&type=template&id=23d0a9b7&scoped=true"
import script from "./releaseMemory.vue?vue&type=script&lang=js"
export * from "./releaseMemory.vue?vue&type=script&lang=js"

import "./releaseMemory.vue?vue&type=style&index=0&id=23d0a9b7&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d0a9b7"]])

export default __exports__